import {WishlistWith} from '@aboutyou/backbone/endpoints/wishlist/getWishlist';
import {BAPI_PRODUCT_SETS, PRODUCT_TILE_SET} from './product.sets';

export const WISHLIST_FULL_SET = Symbol('WISHLIST_FULL_SET');
export const WISHLIST_MINIMAL_SET = Symbol('WISHLIST_MINIMAL_SET');

export type WishlistSetId =
  | typeof WISHLIST_FULL_SET
  | typeof WISHLIST_MINIMAL_SET;

export const BAPI_WISHLIST_SETS: {[K in WishlistSetId]: WishlistWith} = {
  [WISHLIST_FULL_SET]: {
    items: {
      product: {
        ...BAPI_PRODUCT_SETS[PRODUCT_TILE_SET],
        priceRange: true,
      },
    },
  },
  [WISHLIST_MINIMAL_SET]: {},
};
